import { render, staticRenderFns } from "./MaterialImporter.vue?vue&type=template&id=00323fe8&scoped=true"
import script from "./MaterialImporter.vue?vue&type=script&lang=js"
export * from "./MaterialImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00323fe8",
  null
  
)

export default component.exports